import { useAppSelector } from '../app/hooks';
import { selectFeature, selectFeatureSettings } from '../app/slices/features.slice';
import { AppFeature, ComplexAppFeature, ComplexFeatureSettings } from '../types/check/flags';

export const useAppFeature = (feature: AppFeature): boolean => {
	return useAppSelector((state) => selectFeature(state, feature));
};

export const useAppFeatureSettings = <Feature extends ComplexAppFeature>(
	feature: Feature
): ComplexFeatureSettings<Feature> | undefined => {
	return useAppSelector((state) => selectFeatureSettings(state, feature));
};

/**
 * Retrieves the settings for a given complex app feature if it is enabled.
 *
 * @param {ComplexAppFeature} feature - The complex app feature to check.
 * @returns {Object | null} The feature settings if the feature is enabled, otherwise `null`.
 */
export const useSettingsBasedAppFeature = <Feature extends ComplexAppFeature>(
	feature: Feature
): ComplexFeatureSettings<Feature> | null => {
	const featureSettings = useAppFeatureSettings(feature);
	return featureSettings ?? null;
};
